module.exports = __webpack_public_path__ + "static/images/components/Back/images/info-hover.a0dee0d1.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/info-hover.png
// module id = 2494
// module chunks = 11